import * as React from "react";
import styled from "styled-components";
import InlineMessage from "@ingka/inline-message";
import Button from "@ingka/button";
import informationCircle from "@ingka/ssr-icon/paths/information-circle";
import Modal, { ModalFooter, ModalHeader, Prompt } from "@ingka/modal";

import { headerAndFooterHeight } from "../../utils/variables";
import LoadingLayout from "../LoadingLayout";
import { HandleConsentProps } from "./EmailConsent";

interface EmailConsentLayoutProps {
	modalDisagree: boolean;
	setModalDisagree: (val: boolean) => void;
	handleConsent: ({ emailConsentAccepted, isRemoveUser }: HandleConsentProps) => void;
	loading: boolean;
}

const StyledDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: calc(100vh - ${headerAndFooterHeight});
`;

const StyledParagraph = styled.p`
	margin: 0;
`;

const ButtonsContainer = styled.div`
	display: flex;
	gap: 1rem;
	margin-top: 1rem;
	justify-items: end;
`;

const Layout: React.FC<EmailConsentLayoutProps> = ({ modalDisagree, setModalDisagree, handleConsent, loading }) => {
	if (loading) {
		return <LoadingLayout />;
	}
	return (
		<>
			<StyledDiv>
				<InlineMessage
					title="Email, First Name and Last Name Consent"
					headingLevel="1"
					body={
						<div>
							<StyledParagraph>
								To be able to identify you, we are storing your email, first name and last name.
								<br />
								You need to agree to continue to Flagga.
							</StyledParagraph>
							<ButtonsContainer>
								<Button
									type="emphasised"
									text="Agree"
									size="small"
									onClick={() => handleConsent({ emailConsentAccepted: true })}
								/>
								<Button text="Disagree" size="small" onClick={() => setModalDisagree(true)} aria-haspopup="dialog" />
							</ButtonsContainer>
						</div>
					}
					ssrIcon={informationCircle}
				/>
			</StyledDiv>
			<Modal visible={modalDisagree} escapable={false} handleCloseBtn={() => setModalDisagree(false)}>
				<Prompt
					title="Are you sure you don't want us to store your email, first name and last name?"
					titleId=""
					aria-label="Disagree"
					header={<ModalHeader ariaCloseTxt="Close" />}
					footer={
						<ModalFooter>
							<Button
								text="Remove account"
								type="danger"
								onClick={() => handleConsent({ emailConsentAccepted: false, isRemoveUser: true })}
							/>
							<Button text="Cancel" type="emphasised" onClick={() => setModalDisagree(false)} />
						</ModalFooter>
					}
				>
					<p>
						If you don't want us to store your email, first name and last name, your account will be removed from our
						database.
					</p>
				</Prompt>
			</Modal>
		</>
	);
};

export default Layout;
